'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export const ScrollToTop: React.FC = () => {
  const pathname = usePathname();

  // biome-ignore lint/correctness/useExhaustiveDependencies: enforce effect execution on path change
  useEffect(() => {
    window?.scrollTo({ top: 0 });
  }, [pathname]);

  return null;
};
